import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { ArchiveGlcProps } from './ArchiveGlc.types';

export const ArchiveGlc = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  selectedGlc,
}: ArchiveGlcProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <ActionButton type="archive" onClick={onModalOpen} />

      <ActionModal
        header={formatMessage({ id: AppMessages['glc.archive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['glc.archive.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['glc.archive.subtitle'] })} {selectedGlc.nazwa}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['glc.archive.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
